export const RECEIPT_TYPE_NAME = 'receiptType';
export const APPLYING_BONUS_NAME = 'applyingBonus';
export const PAYMENT_NAME = 'payment';
export const ADDRESS_NAME = 'address';
export const CHANGE_ADDRESS_NAME = 'changeAddress';
export const SET_ADDRESS_NAME = 'setAddress';
export const TIME_SLOTS_NAME = 'timeSlots';
export const OPTIONS_NAME = 'options';
export const ADDRESS_ID = 'addressId';
export const DELIVERY = 'delivery';
export const PICKUP = 'pickup';
export const MANAGER_WILL_CLARIFY_STATE = 'managerWillClarifyState';
